import { render } from "./DenuvoTicketCandidates.vue?vue&type=template&id=44b93f26&scoped=true"
import script from "./DenuvoTicketCandidates.vue?vue&type=script&lang=js"
export * from "./DenuvoTicketCandidates.vue?vue&type=script&lang=js"

import "./DenuvoTicketCandidates.vue?vue&type=style&index=0&id=44b93f26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b93f26"]])

export default __exports__